<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 14:35:21
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-04-16 11:57:03
-->
<template>
  <div class="data-board">
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>数据概览</span>
    </div>
    <div class="data-list">
      <div class="data-item" @click="handleClick(1)">
        <div class="value">
          <countTo
            :start-val="start.productCount"
            :end-val="data.productCount"
            separator=""
            :duration="countToDuration"
          ></countTo>
        </div>
        <div class="key">商品数量</div>
      </div>
      <div class="data-item" @click="handleClick(2)">
        <div class="value">
          <countTo
            :start-val="start.personalCustomerCount"
            :end-val="data.personalCustomerCount"
            separator=""
            :duration="countToDuration"
          ></countTo>
        </div>
        <div class="key">个人客户数量</div>
      </div>
      <div class="data-item" @click="handleClick(3)">
        <div class="value">
          <countTo
            :start-val="start.businessCustomerCount"
            :end-val="data.businessCustomerCount"
            separator=""
            :duration="countToDuration"
          ></countTo>
        </div>
        <div class="key">企业客户数量</div>
      </div>
      <div class="data-item" @click="handleClick(4)">
        <div class="value">
          <countTo
            :start-val="start.supplierCount"
            :end-val="data.supplierCount"
            separator=""
            :duration="countToDuration"
          ></countTo>
        </div>
        <div class="key">供应商数量</div>
      </div>
      <div class="data-item" @click="handleClick(5)">
        <div class="value">
          <countTo
            :start-val="start.retailOrderCount"
            :end-val="data.retailOrderCount"
            separator=""
            :duration="countToDuration"
          ></countTo>
        </div>
        <div class="key">零售订单</div>
      </div>
      <div class="data-item" @click="handleClick(5)">
        <div class="value">
          <countTo
            :start-val="start.retailSalesAmount"
            :end-val="data.retailSalesAmount"
            separator=""
            :duration="countToDuration"
            :decimals="2"
          ></countTo>
        </div>
        <div class="key">零售销售额（万元）</div>
      </div>
      <div class="data-item" @click="handleClick(6)">
        <div class="value">
          <countTo
            :start-val="start.businessOrderCount"
            :end-val="data.businessOrderCount"
            separator=""
            :duration="countToDuration"
          ></countTo>
        </div>
        <div class="key">企业批量订单</div>
      </div>
      <div class="data-item" @click="handleClick(6)">
        <div class="value">
          <countTo
            :start-val="start.businessSalesAmount"
            :end-val="data.businessSalesAmount"
            separator=""
            :duration="countToDuration"
            :decimals="2"
          ></countTo>
        </div>
        <div class="key">企业批量销售额（万元）</div>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from 'vue-count-to'
export default {
  components: { countTo },
  data() {
    return {
      type: 3,
      data: {
        productCount: 0,
        personalCustomerCount: 0,
        businessCustomerCount: 0,
        supplierCount: 0,
        retailOrderCount: 0,
        retailSalesAmount: 0,
        businessOrderCount: 0,
        businessSalesAmount: 0,
      },
      start: {
        productCount: 0,
        personalCustomerCount: 0,
        businessCustomerCount: 0,
        supplierCount: 0,
        retailOrderCount: 0,
        retailSalesAmount: 0,
        businessOrderCount: 0,
        businessSalesAmount: 0,
      },
      countToDuration: 3000,
    }
  },
  methods: {
    async initData(res) {
      console.log(`output->res.data`, res.data)
      for (const key in this.data) {
        if (Object.hasOwnProperty.call(this.data, key)) {
          const count = this.data[key]
          if (count != res.data[key]) {
            const index = Object.keys(this.data).indexOf(key) // 获取属性的数字索引
            document.querySelectorAll('.data-item')[index].className = 'data-item highlight'
            setTimeout(() => {
              document.querySelectorAll('.data-item')[index].className = 'data-item'
            }, 1000)
          }
        }
      }
      const {
        productCount,
        personalCustomerCount,
        businessCustomerCount,
        supplierCount,
        retailOrderCount,
        retailSalesAmount,
        businessOrderCount,
        businessSalesAmount,
      } = res.data
      this.data = {
        productCount: productCount - 0,
        personalCustomerCount: personalCustomerCount - 0,
        businessCustomerCount: businessCustomerCount - 0,
        supplierCount: supplierCount - 0,
        retailOrderCount: retailOrderCount - 0,
        retailSalesAmount: retailSalesAmount - 0,
        businessOrderCount: businessOrderCount - 0,
        businessSalesAmount: businessSalesAmount - 0,
      }
    },
    handleClick(index) {
      this.$emit('click', index)
    },
  },
}
</script>
<style lang="scss" scoped>
.data-board {
  position: relative;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 25px 60px;
  .title {
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    margin-bottom: 44px;
    display: flex;
    align-items: center;
    img {
      margin-right: 3px;
    }
  }
  .tab {
    z-index: 99;
    position: absolute;
    right: 26px;
    top: 36px;
    display: flex;
    .tab-item {
      width: 64px;
      height: 31px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #15535e;
      text-align: center;
      line-height: 29px;
      color: rgba(255, 255, 255, 0.8);
      &.active {
        color: #66ffff;
      }
    }
  }
}
.data-list {
  display: flex;
  flex-wrap: wrap;
  .data-item {
    cursor: pointer;
    position: relative;
    width: 271px;
    height: 163px;
    text-align: center;
    background: url('~@/img/datav/data_item_bg.png') no-repeat center;
    background-size: contain;
    margin-right: 38px;
    box-sizing: border-box;
    padding-top: 32px;
    margin-bottom: 32px;
    transition: transform 0.5s ease, color 0.5s ease;
    &.highlight {
      transform: scale(1.2);
      color: #ffcc00;
    }
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    .key {
      font-weight: 400;
      font-size: 26px;
      color: #ffffff;
      line-height: 27px;
      text-align: center;
      white-space: nowrap;
    }
    .value {
      opacity: 1;
      font-weight: bold;
      font-size: 44px;
      color: #66ffff;
      line-height: 44px;
      text-align: center;
      margin-bottom: 22px;
      &.light {
        color: #ffbd27;
      }
    }
  }
}
</style>
